import Vue from 'vue';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;

if ( 'serviceWorker' in navigator && process.env.NODE_ENV === 'production' ) {
    // Use the window load event to keep the page load performant
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js');
    });
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
